/**
 * Helpers for preview image loading strategy.
 *
 * Used by PreviewCloudinaryImage to decide whether to render images immediately
 * or wrap them in Lazy (skeleton placeholder). Local init assets and init-preview
 * mode should load eagerly to avoid slow or stuck placeholders on cached images.
 */

const STATIC_PREVIEW_ASSET_PREFIXES = ["/images/phone-previews/", "/images/previews/"] as const;

export const isStaticPreviewAsset = (src?: string): boolean => {
  if (!src) {
    return false;
  }

  return STATIC_PREVIEW_ASSET_PREFIXES.some((prefix) => src.startsWith(prefix));
};

export const shouldEagerLoadPreviewImage = (src?: string, isInitPreview = false): boolean => {
  return isInitPreview || isStaticPreviewAsset(src);
};
